module.exports = {"en":{"new":"New","areYouSure":"Are you sure?","clearButton":"Clear","cancelButton":"Cancel","saveButton":"Save","createButton":"Create","openButton":"Open","undo":"Undo","redo":"Redo","browse":"Browse","delete":"Delete","shoppingList":"Shopping List"},"es":{"new":"Nuevo","areYouSure":"¿Está seguro?","clearButton":"Borrar","cancelButton":"Cancelar","saveButton":"Salvar","createButton":"Crear","openButton":"Abrir","undo":"Deshacer","redo":"Rehacer","browse":"Inicio","delete":"Borrar","shoppingList":"Lista de compras"}}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/global.i18n.json
// module id = AwED
// module chunks = 1